<template>
  <!--begin::Card-->
  <div class="card card-custom">
    <!--begin::Header-->
    <div class="card-header py-3">
      <div class="card-title">
        <h3 class="card-label font-weight-bolder text-dark">اطلاعات شخصی</h3>
      </div>
      <div class="card-toolbar">
        <button
          type="reset"
          class="btn btn-sm btn-primary mr-2"
          @click="save()"
          ref="kt_save_changes"
        >
          ذخیره
        </button>
        <button
          type="reset"
          class="btn btn-sm btn-secondary btn-danger mr-1"
          @click="cancel()"
        >
          انصراف
        </button>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <form class="form" id="info_form">
      <!--begin::Body-->
      <div class="card-body">
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-alert">
            نام
          </label>
          <div class="col-lg-9 col-xl-6">
            <input
              name="first_name"
              ref="first_name"
              class="form-control form-control-lg form-control-solid"
              type="text"
              v-bind:value="currentUserPersonalInfo.first_name"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-alert">
            نام‌خانوادگی
          </label>
          <div class="col-lg-9 col-xl-6">
            <input
              name="last_name"
              ref="last_name"
              class="form-control form-control-lg form-control-solid"
              type="text"
              v-bind:value="currentUserPersonalInfo.last_name"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-3 col-lg-3 col-form-label text-alert">
            ایمیل
          </label>
          <div class="col-lg-9 col-xl-6">
            <input
              name="email"
              ref="email"
              type="text"
              class="form-control form-control-lg form-control-solid"
              placeholder="Email"
              dir="ltr"
              v-bind:value="currentUserPersonalInfo.email"
            />
          </div>
        </div>
      </div>
      <!--end::Body-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { UPDATE_PERSONAL_INFO } from "@/core/services/store/profile.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";

export default {
  name: "PersonalInformation",
  mounted() {
    const info_form = document.getElementById("info_form");

    this.fv = formValidation(info_form, {
      fields: {
        email: {
          validators: {
            emailAddress: {
              message: "ایمیل درست نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  methods: {
    save() {
      let $this = this;
      this.fv.validate().then(function(status) {
        if (status === "Valid") {
          let first_name = $this.$refs.first_name.value;
          let last_name = $this.$refs.last_name.value;
          let email = $this.$refs.email.value;

          const submitButton = $this.$refs["kt_save_changes"];
          $this.disableBtn(submitButton);

          $this.$store
            .dispatch(UPDATE_PERSONAL_INFO, {
              first_name,
              last_name,
              email
            })
            .then(() => {
              $this.enableBtn(submitButton);
            })
            .catch(() => {
              $this.enableBtn(submitButton);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا  اطلاعات را به طور صحیح وارد نمایید");
        }
      });
    },
    cancel() {
      this.$refs.first_name.value = this.currentUserPersonalInfo.first_name;
      this.$refs.last_name.value = this.currentUserPersonalInfo.last_name;
      this.$refs.email.value = this.currentUserPersonalInfo.email;
    }
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo"])
  }
};
</script>
